import { useNavigate } from 'react-router'
import { Box, Button, Grid, Link, Typography } from '@mui/material'

import BackButton from '../../components/back-button'
import ScreenContainer from '../../components/screen'
import SensorActivationFooter from '../../components/sensor-activation-footer'
import avoidHighSplash from '../../images/leak-freeze-activation/where-to-avoid/avid-high-splash.svg'
import avoidAppliances from '../../images/leak-freeze-activation/where-to-avoid/avoid-appliances.svg'
import avoidOutside from '../../images/leak-freeze-activation/where-to-avoid/avoid-outside.svg'
import avoidOutsideCommercial from '../../images/leak-freeze-activation/where-to-avoid/avoid-outside-commercial.svg'
import avoidUnderneathAppliances from '../../images/leak-freeze-activation/where-to-avoid/avoid-underneath-appliances.svg'
import { useActivationContext } from '../../providers/activation-provider'
import useFolderTheme from '../../utils/hooks/useFolderTheme'

import useStyles from './index.styles'

const WhereToAvoid = () => {
  const classes = useStyles
  const { activationLocationState, loading: activationLoading } = useActivationContext()
  const { nodeTypeName, folderId } = activationLocationState

  const { folderTheme } = useFolderTheme(folderId)

  const isCommercialLocationType = folderTheme?.locationType === 'Commercial Lines'

  const navigate = useNavigate()

  return (
    <ScreenContainer
      useDarkBackground={true}
      loading={activationLoading}
      headerProps={{
        title: 'Where to avoid',
        showDownloadAppButton: false,
        leftIcon: <BackButton />,
        useDarkBackground: true,
        progress: 23,
      }}
      footerSpacing={148}
    >
      <Grid container={true} sx={classes.container}>
        <Grid container={true} sx={classes.avoidItemContainer}>
          <Grid size={6}>
            <Box sx={classes.imageContainer}>
              <img src={avoidAppliances} alt="Avoid on or near appliances" style={classes.avoidImage} />
            </Box>
          </Grid>

          <Grid size={6} container={true} sx={classes.textContainer}>
            <Typography variant="body1" sx={classes.text}>
              Do not place sensor inside appliances (refrigerators or washers)
            </Typography>
          </Grid>
        </Grid>

        <Grid container={true} sx={classes.avoidItemContainer}>
          <Grid size={6}>
            <Box sx={classes.imageContainer}>
              <img src={avoidUnderneathAppliances} alt="Avoid underneath appliances" style={classes.avoidImage} />
            </Box>
          </Grid>

          <Grid size={6} container={true} sx={classes.textContainer}>
            <Typography variant="body1" sx={classes.text}>
              Do not place sensor far underneath appliances – signal may fail
            </Typography>
          </Grid>
        </Grid>

        <Grid container={true} sx={classes.avoidItemContainer}>
          <Grid size={6}>
            <Box sx={classes.imageContainer}>
              <img src={avoidHighSplash} alt="Avoid high splash areas" style={classes.avoidImage} />
            </Box>
          </Grid>

          <Grid size={6} container={true} sx={classes.textContainer}>
            <Typography variant="body1" sx={classes.text}>
              Do not place sensor in high-traffic or splash-prone locations
            </Typography>
          </Grid>
        </Grid>

        <Grid container={true} sx={classes.avoidItemContainer}>
          <Grid size={6}>
            <Box sx={classes.imageContainer}>
              <img src={isCommercialLocationType ? avoidOutsideCommercial : avoidOutside} alt="Avoid outside" style={classes.avoidImage} />
            </Box>
          </Grid>

          <Grid size={6} container={true} sx={classes.textContainer}>
            <Typography variant="body1" sx={classes.text}>
              Do not place sensor outdoors or in spaces without climate control
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <SensorActivationFooter
        primaryButton={
          <Button variant="contained" disableElevation color="secondary" onClick={() => navigate('/turn-on-sensor', { state: activationLocationState })}>
            Continue
          </Button>
        }
        secondaryButton={
          nodeTypeName === 'leak5s' ? (
            <Link href="https://resources.meshify.com/defender-slim/placement-suggestions/" rel="noopener noreferrer" target="_blank" underline="hover">
              See more placement tips
            </Link>
          ) : undefined
        }
      />
    </ScreenContainer>
  )
}

export default WhereToAvoid
